import type { OperationDefinitionNode } from "graphql"
import type { DocumentInput, Operation, UseSubscriptionArgs } from "urql"

export function getOperationName(operation: Operation) {
  return getQueryName(operation.query)
}

function getQueryName(query: DocumentInput): string {
  if (typeof query === "string") {
    return query
  }

  return (
    (query.definitions[0] as OperationDefinitionNode).name?.value || "Unknown"
  )
}

export function getSubscriptionId(args: UseSubscriptionArgs): string {
  return `${getQueryName(args.query)}-${JSON.stringify(args.variables ?? {})}`
}
